import { List, ListItemButton, ListItemText } from "@mui/material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { useAsync2 } from "nate-react-api-helpers";
import { useState } from "react";
import { api } from "../../../api/API";
import { Project } from "../../../api/Projects";
import { ProjectRef } from "../panel/TaskProject";
import { ProjectCode } from "../../project/ProjectCode";
import { BottomSheet } from "./BottomSheet";

// MobileProjectSheet files the task under a project of its team, then under one of that
// project's goals
export function MobileProjectSheet(props: {
    open: boolean;
    team: number;
    onClose: () => void;
    onChange: (value: ProjectRef | null) => void;
}) {
    const [picked, setPicked] = useState<Project | null>(null);

    const projects = useAsync2(input => input.open ? api.projects.list(input.filter) : Promise.resolve([]),
        { open: props.open, filter: { team: props.team, archived: false } }, [props.open, props.team]);

    const close = () => {
        setPicked(null);
        props.onClose();
    };

    const choose = (value: ProjectRef | null) => {
        props.onChange(value);
        close();
    };

    if (picked) {
        const goals = picked.goals.filter(goal => !goal.archived);

        return (
            <BottomSheet open={props.open} title={picked.name} onClose={close}>
                <List disablePadding>
                    <ListItemButton onClick={() => choose({
                        id: picked.id, name: picked.name, color: picked.color, goal: 0, goalName: "",
                    })}>
                        <ListItemText primary="No goal" />
                    </ListItemButton>
                    {goals.map(goal => (
                        <ListItemButton key={goal.id} onClick={() => choose({
                            id: picked.id, name: picked.name, color: picked.color, goal: goal.id, goalName: goal.name,
                        })}>
                            <ListItemText primary={goal.name} />
                        </ListItemButton>
                    ))}
                </List>
            </BottomSheet>
        );
    }

    return (
        <BottomSheet open={props.open} title="Project" onClose={close}>
            {projects.LoadingOrErrorElement}
            <List disablePadding>
                <ListItemButton onClick={() => choose(null)}>
                    <ListItemText primary="None" />
                </ListItemButton>
                {(projects.result || []).map(project => (
                    <ListItemButton key={project.id} onClick={() => {
                        // a project with no goals has nothing more to pick
                        if (project.goals.some(goal => !goal.archived)) setPicked(project);
                        else choose({ id: project.id, name: project.name, color: project.color, goal: 0, goalName: "" });
                    }}>
                        <ListItemText primary={<>
                            <ProjectCode code={project.code} color={project.color} />{" "}{project.name}
                        </>} />
                        {project.goals.some(goal => !goal.archived) && <ChevronRight color="action" />}
                    </ListItemButton>
                ))}
            </List>
        </BottomSheet>
    );
}
